import React from 'react';
import { CheckIcon, EyeIcon, EditIcon, ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
interface AIExtractionProps {
  onNext: () => void;
  onBack: () => void;
}
export const AIExtraction: React.FC<AIExtractionProps> = ({
  onNext,
  onBack
}) => {
  // Mock data for the AI extraction results
  const extractionResults = {
    floors: [{
      id: 1,
      name: 'Stueetage',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tcr6DP63jc4WCk7ZMhFsgh/plan.jpg',
      confidence: 95
    }, {
      id: 2,
      name: '1. sal',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tcr6DP63jc4WCk7ZMhFsgh/plan.jpg',
      confidence: 92
    }],
    stats: {
      floors: 2,
      rooms: 8,
      manifolds: 3,
      unheatedZones: 12.5
    },
    systemSuggestions: [{
      zone: 'Stue/Køkken',
      system: 'QuickTemp Compact Basic',
      cc: 150,
      pipe: 16
    }, {
      zone: 'Badeværelse',
      system: 'QuickTemp Premium',
      cc: 100,
      pipe: 16
    }],
    warnings: [{
      type: 'warning',
      message: 'Mangler dørtrin i Værelse 2'
    }, {
      type: 'warning',
      message: 'Usikker rumgrænse ved køkken/stue'
    }]
  };
  return <div className="mb-20" data-id="element-34">
      <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6" data-id="element-35">
        <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-36">
          {/* Left column - Floor plan thumbnails */}
          <div className="p-6 border-r border-gray-200" data-id="element-37">
            <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-38">
              Udtræk af tegninger
            </h2>
            <div className="space-y-6" data-id="element-39">
              {extractionResults.floors.map(floor => <div key={floor.id} className="relative" data-id="element-40">
                  <div className="relative rounded-lg overflow-hidden border border-gray-300" data-id="element-41">
                    <img src={floor.image} alt={`Plantegning for ${floor.name}`} className="w-full h-64 object-contain" data-id="element-42" />
                    <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-5" data-id="element-43"></div>
                    {/* Overlay with confidence badge */}
                    <div className="absolute top-3 right-3 bg-white rounded-full px-3 py-1 text-xs font-medium shadow-sm" data-id="element-44">
                      Confidence {floor.confidence}%
                    </div>
                    <div className="absolute bottom-3 left-3 text-white text-lg font-medium drop-shadow-md bg-black bg-opacity-30 px-2 py-1 rounded" data-id="element-45">
                      {floor.name}
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Right column - Results */}
          <div className="p-6" data-id="element-46">
            <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-47">
              AI-udtræk resultater
            </h2>
            <div className="mb-6" data-id="element-48">
              <h3 className="text-gray-700 font-medium mb-3" data-id="element-49">Fundet</h3>
              <div className="flex flex-wrap gap-2 mb-4" data-id="element-50">
                <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm" data-id="element-51">
                  Etager: {extractionResults.stats.floors}
                </div>
                <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm" data-id="element-52">
                  Rum: {extractionResults.stats.rooms}
                </div>
                <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm" data-id="element-53">
                  Manifolder: {extractionResults.stats.manifolds}
                </div>
                <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm" data-id="element-54">
                  Ikke-opvarmede zoner: {extractionResults.stats.unheatedZones}{' '}
                  m²
                </div>
              </div>
            </div>
            <div className="mb-6" data-id="element-55">
              <h3 className="text-gray-700 font-medium mb-3" data-id="element-56">
                Systemforslag pr. zone
              </h3>
              <div className="space-y-3" data-id="element-57">
                {extractionResults.systemSuggestions.map((suggestion, index) => <div key={index} className="p-3 bg-gray-50 rounded-lg border border-gray-200" data-id="element-58">
                      <div className="font-medium text-gray-800 mb-1" data-id="element-59">
                        {suggestion.zone}
                      </div>
                      <div className="text-sm text-gray-600" data-id="element-60">
                        {suggestion.system}, C/C {suggestion.cc}, rør{' '}
                        {suggestion.pipe} mm
                      </div>
                    </div>)}
              </div>
            </div>
            <div className="mb-6" data-id="element-61">
              <h3 className="text-gray-700 font-medium mb-3" data-id="element-62">Bemærkninger</h3>
              <div className="space-y-2" data-id="element-63">
                {extractionResults.warnings.map((warning, index) => <div key={index} className="flex items-start" data-id="element-64">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-amber-100 flex items-center justify-center mt-0.5 mr-2" data-id="element-65">
                      <span className="text-amber-600 text-xs" data-id="element-66">!</span>
                    </div>
                    <div className="text-sm text-gray-700" data-id="element-67">
                      {warning.message}
                    </div>
                  </div>)}
              </div>
            </div>
            <div className="flex space-x-3 mt-8" data-id="element-68">
              <button className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-69">
                <EyeIcon className="w-4 h-4 mr-2" data-id="element-70" />
                Vis overlay
              </button>
              <button className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-71">
                <EditIcon className="w-4 h-4 mr-2" data-id="element-72" />
                Ret manuelt
              </button>
              <button onClick={onNext} className="flex items-center px-4 py-2 bg-[#E3000F] text-white rounded-md hover:bg-red-700 transition-colors ml-auto" data-id="element-73">
                <CheckIcon className="w-4 h-4 mr-2" data-id="element-74" />
                Godkend AI-udtræk
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between" data-id="element-75">
        <button onClick={onBack} className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors" data-id="element-76">
          <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-77" />
          Tilbage
        </button>
      </div>
    </div>;
};